import { useElementSize } from '@mantine/hooks';
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts';
import constants from '../../../../constants';

const ClosedStatusBreakdown = ({ data = [] }) => {
	const { ref, width } = useElementSize();

	const counts = {};
	data.forEach((row) => {
		if (!constants.closedStatuses.includes(row.request_status)) return;
		if (row.request_status === 'completed') return;
		counts[row.request_status] = (counts[row.request_status] || 0) + 1;
	});

	const entries = Object.entries(counts);
	const labels = entries.map(([s]) =>
		(constants.status[s] || s).replace(/^Service Not Provided:\s*/, ''),
	);
	const series = entries.map(([, count]) => count);

	return (
		<div ref={ref}>
			<div className="text-xl">Service Not Provided Breakdown</div>
			{series.length === 0 ? (
				<div className="mt-4 text-center text-gray-500">
					No closed referrals available
				</div>
			) : (
				<Chart
					type="pie"
					width={width}
					height={400}
					options={{
						labels,
						legend: { position: 'bottom' },
						dataLabels: { enabled: false },
						tooltip: {
							y: {
								formatter: (v) => `${v} referral${v === 1 ? '' : 's'}`,
							},
						},
					}}
					series={series}
				/>
			)}
		</div>
	);
};

ClosedStatusBreakdown.propTypes = {
	data: PropTypes.array,
};

export default ClosedStatusBreakdown;
